import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionSendEmailCodes = {
  AutomationV2ExecutionActionSendEmailFailedToSendEmail: {
    code: 'automation-v2-execution-action/send-email-failed-to-send-email',
    explanation: `Erro no serviço de envio de e-mails.

**Causas comuns:**
- Problema no provedor de e-mail (SMTP)
- Rate limit excedido

**Como diagnosticar:**
Tente reexecutar a automação.`,
    localizations: {},
    message: 'A automação não conseguiu enviar o e-mail.',
    supportingDocs: [
      {
        name: 'Ação de Enviar E-mail',
        path: '/wiki/docs/automations/actions/send-email',
      },
    ],
  },
  AutomationV2ExecutionActionSendEmailInvalidDomain: {
    code: 'automation-v2-execution-action/send-email-invalid-domain',
    explanation: `Domínio do remetente ou destinatário inválido ou bloqueado.

**Causas comuns:**
- Domínio sem registros MX válidos
- Domínio na blacklist de spam

**Como resolver:**
Use domínios de e-mail válidos e confiáveis.`,
    localizations: {},
    message: 'O domínio do e-mail é inválido.',
    supportingDocs: [
      {
        name: 'Ação de Enviar E-mail',
        path: '/wiki/docs/automations/actions/send-email',
      },
    ],
  },
  AutomationV2ExecutionActionSendEmailInvalidEmailFormat: {
    code: 'automation-v2-execution-action/send-email-invalid-email-format',
    explanation: `Endereço de e-mail mal formatado detectado.

**Causas comuns:**
- Falta de \`@\` ou domínio
- Caracteres inválidos no endereço

**Como resolver:**
Verifique o formato dos endereços de e-mail (ex: \`nome@dominio.com\`).`,
    localizations: {},
    message: 'O formato do e-mail é inválido.',
    supportingDocs: [
      {
        name: 'Ação de Enviar E-mail',
        path: '/wiki/docs/automations/actions/send-email',
      },
    ],
  },
  AutomationV2ExecutionActionSendEmailMissingBody: {
    code: 'automation-v2-execution-action/send-email-missing-body',
    explanation: `Conteúdo da mensagem vazio.

**Causas comuns:**
- Campo de corpo do e-mail não preenchido
- Variável de template vazia

**Como resolver:**
Escreva o conteúdo da mensagem na configuração da ação.`,
    localizations: {},
    message:
      'O corpo do e-mail está faltando. Verifique se o corpo existe no contexto da automação ou se foi digitado corretamente.',
    supportingDocs: [
      {
        name: 'Ação de Enviar E-mail',
        path: '/wiki/docs/automations/actions/send-email',
      },
      {
        name: 'Informações Dinâmicas',
        path: '/wiki/docs/automations/informacoes-dinamicas',
      },
    ],
  },
  AutomationV2ExecutionActionSendEmailMissingRecipients: {
    code: 'automation-v2-execution-action/send-email-missing-recipients',
    explanation: `Nenhum destinatário definido para o e-mail.

**Causas comuns:**
- Campo "Para" vazio
- Variável dinâmica de e-mail vazia

**Como resolver:**
Defina pelo menos um destinatário válido na ação.`,
    localizations: {},
    message: 'Os destinatários do e-mail estão faltando.',
    supportingDocs: [
      {
        name: 'Ação de Enviar E-mail',
        path: '/wiki/docs/automations/actions/send-email',
      },
      {
        name: 'Informações Dinâmicas',
        path: '/wiki/docs/automations/informacoes-dinamicas',
      },
    ],
  },
  AutomationV2ExecutionActionSendEmailMissingSubject: {
    code: 'automation-v2-execution-action/send-email-missing-subject',
    explanation: `Assunto do e-mail vazio.

**Causas comuns:**
- Campo "Assunto" não preenchido

**Como resolver:**
Adicione um assunto ao e-mail para evitar que caia em spam.`,
    localizations: {},
    message: 'O assunto do e-mail está faltando.',
    supportingDocs: [
      {
        name: 'Ação de Enviar E-mail',
        path: '/wiki/docs/automations/actions/send-email',
      },
    ],
  },
  AutomationV2ExecutionActionSendEmailNoValidRecipientsProvided: {
    code: 'automation-v2-execution-action/send-email-no-valid-recipients-provided',
    explanation: `Todos os destinatários fornecidos foram considerados inválidos.

**Causas comuns:**
- Lista de e-mails com erros de digitação
- E-mails bloqueados pelo sistema

**Como diagnosticar:**
Revise a lista de e-mails destinatários.`,
    localizations: {},
    message: 'Nenhum destinatário válido foi fornecido.',
    supportingDocs: [
      {
        name: 'Ação de Enviar E-mail',
        path: '/wiki/docs/automations/actions/send-email',
      },
    ],
  },
  AutomationV2ExecutionActionSendEmailUndeliverableEmail: {
    code: 'automation-v2-execution-action/send-email-undeliverable-email',
    explanation: `Bounce ou rejeição imediata do servidor de e-mail.

**Causas comuns:**
- Caixa de entrada do destinatário cheia
- Domínio de destino rejeitou a conexão

**Como resolver:**
Verifique se o e-mail do destinatário está correto e ativo.`,
    localizations: {},
    message: 'O endereço de e-mail especificado não pôde ser entregue.',
    supportingDocs: [
      {
        name: 'Ação de Enviar E-mail',
        path: '/wiki/docs/automations/actions/send-email',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
